module.exports = __webpack_public_path__ + "img/video.536cdf35.png";